import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { APP_ROUTES } from '../../../constants/routes.const';

// Evita que un usuario autenticado acceda a la página de login
export const AuthenticatedGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    router.navigate([`/${APP_ROUTES.DASHBOARD}`]).then();
    return false;
  }

  return true;
};
